import * as React from 'react';

const UndoChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9 17v-.5c0-2.5-1.4-4.7-3.5-5.8-1.5-.8-3.2-.8-4.7-.3-.9.4-1.7 1-2.2 1.6h3.6v2h-7V7h2v3.4c.8-.9 1.8-1.5 2.9-1.9 2.1-.8 4.3-.6 6.3.4 2.8 1.4 4.6 4.4 4.6 7.6v.5h-2z"
        />
    </svg>
);

UndoChunkySvg.displayName = 'UndoChunkySvg';
export default UndoChunkySvg;
